<div class="SLV2-tpcsumry-sidebar">

    <div class="SLV2-tpcsumry-hdng-section">
        <h3 class="SLV2-tpcsumry-hdng-text">Summaries</h3>
        <span class="SLV2-tpcsumry-complte-count">Completed - {{selectedFlashCardData.flashcardTaggedQuestionsCount>0? (isRevisionQuestionsCompleted ? completedCount:completedCount)+"/"+(TopicSummaryData.length+1) : completedCount+"/"+TopicSummaryData.length}}</span>
    </div>

    <div class="SLV2-tpcsumry-cards-wrap">
        <!-- {{currentTopicIndex}} -->
        <ol class="SLV2-tpcsumry-list">
            <ng-container *ngFor="let item of TopicSummaryData; let i = index">
                <li (click)="selectTopicFromTopiclist(i)" [ngClass]="{'current': i == currentTopicIndex, 'completed':item.completed}">
                    <div class="SLV2-sumry-number">
                        <img src="selflearnv2-ui/assets/img/self-learn-v2/green-tick.svg" />
                    </div>
                    <div class="SLV2-sumry-cont">{{item.title}}</div>
                </li>
            </ng-container>
            <li *ngIf="taggedQuestionIds.length > 0" [ngClass]="isRevisionQuestionsCompleted ?  'completed' : '' ">
                <div class="SLV2-sumry-number">
                    <img src="selflearnv2-ui/assets/img/self-learn-v2/green-tick.svg" />
                </div>
                <div class="SLV2-sumry-cont" (click)="selectTopicFromTopiclist(TopicSummaryData.length)">Revision Questions</div>
                </li>
        </ol>

    </div>

</div>

